export const baseWidgetUrl = 'https://widget-instant.ramp.network';
